import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { NotFound404Icon } from 'src/shared/components/icons';
import { getCurrentCulture } from 'src/store/localizations/localizations.selectors';

/*
    Notes : Edge cases when the translations api would fail, the following strings are stored at this level.
    If the user's language preference cannot be retrieved as well, then the language is determined using the browser's
    default language.
 */
export const NotFound404Page: FC = () => {
  const currentCulture = useSelector(getCurrentCulture);
  const { title, message } = getLocalizedStrings(currentCulture);

  return (
    <div id="page-wrapper">
      <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column">
        <NotFound404Icon />
        <div className="px-3 mt-5 text-center">
          <h1 className="h4 fw-medium">{title}</h1>
          <p className="text-muted my-3">{message}</p>
        </div>
      </div>
    </div>
  );
};

const getLocalizedStrings = (culture: string): { title: string; message: string } => {
  switch (culture.substring(0, 2).toLowerCase()) {
    case 'fr':
      return {
        message: "Veuillez vérifier l'adresse URL et essayer de nouveau ou contactez votre administrateur système",
        title: 'Désolé! La page que vous recherchez est introuvable',
      };
    case 'es':
    case 'en':
    default:
      return {
        message: 'Please check the URL and try again or contact your system administrator',
        title: 'Sorry! The page you’re looking for cannot be found',
      };
  }
};
